<template>
    <div>
        <div class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Service"
                @click="showAddService">
                <span class="fal fa-plus mr-2"></span>
                <span>Add Section</span>
            </button>
        </div>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 mb-2 align-items-center justify-content-start">
                            <div class="dataTables_filter">
                                <label class="d-flex mb-0">
                                    <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
                                        :placeholder="$t('label.search')" v-model="searchService" @keypress.enter="searchServiceItem">
                                    <button
                                        class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0"
                                        @click="searchServiceItem">
                                        <i class="fas fa-search"></i>
                                    </button>
                                </label>
                            </div>
                        </div>
                    </div>
                    <a class="link text-primary" @click="clearFilter()">{{ $t('button_link.clear_filter') }}</a>
                </div>
                <div class="panel-container show">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">{{ $t('table.no_records') }}</div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>
                                        {{ $t('table.pagination', { 'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries, }) }}
                                    </span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries"
                                        @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div v-if="!isSpinnerShow && totalEntries != 0" class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table striped hover bordered :fields="fields" :items="serviceItems" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(name)="data">
                                            <a class="text-primary fw-500 link" @click="showEditService(data.item)">{{ data.item.name }}</a>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sectionForm
            ref="dataModal"
            :isEdit="true"
            @onServiceAddOrEdit="onServiceAddOrEdit"
            @onServiceChange="onServiceChange">
        </sectionForm>
    </div>
</template>

<script>
import moment from 'moment'
import SectionForm from './Section_Form'
import { formatTime, formatPrice, formFormatTime } from './../../../../assets/js/dashboard/utilities'
import { setReturnData, handleSessionExpired, setCategoryLabel, getSubcategory, getCategoryText }
    from './../../../../assets/js/dashboard/dashboard'


export default {
    name: 'sectionList',
    components: {
        SectionForm,
    },
    data() {
        return {
            typeID: 1,
            
            isSpinnerShow: true,
            searchService: "", 
            serviceItems: [],
            selectedItem: {},
            editToggleModal: false,
            deleteToggleModal: false,

            page: 0,
            totalEntries: 0,
            totalPage: 0,
            startPage: 1,
            endPage: 0,
            perPage: 100,
            currentPage: 1,

            exportHeaders: [], 
            exportData: [],
            exportFileName: "",
            serviceExportData: [],
        }
    },
    computed: {
        fields() {
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle' },
                { key: "name", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', tdCtdClass: 'align-middle text-center' },
            ]
        },
        exportFields() {
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "name"
            return ret
        },
    },
    methods: {
        clearFilter() {
            this.isEnable = true;
            this.searchService = "";
            this.getServiceItem()
        },
        searchServiceItem() {
            var strFilter = this.searchService == "" ? "" : "&search=" + this.searchService;
            this.getServiceItem(strFilter);

            // this.selectedTab = "all";
            // this.selectedSubcategory = this.subCategory[0];
            // this.isEnable = true;
        },
        filterEnable(e) {
            this.isEnable = e.target.checked ? true : false;
            this.getServiceItem()
        },
        async getServiceItem() {
            let $vm = this;
            let QUERY_STRING = "?typeID=" + this.typeID
            if(this.searchService) {
                QUERY_STRING += '&search=' + this.searchService
            }
            let url = 'https://menu.tunai.io/business/sections' + QUERY_STRING;
            url += "&page=" + this.page

            this.isSpinnerShow = true
            await $vm.$axios({
                method: 'get',
                url: url,
                // baseURL: this.$axios.defaults.baseURL, 
                headers: { token: $vm.$session.get('token') }
            })
                .then((response) => {
                    let temp = response.data.sections
                    response.data.items = temp
                    response.data.count = temp.length

                    var retData = setReturnData(response.data.items, response.data.count, $vm.page)
                    $vm.serviceItems = retData.result;
                    $vm.totalEntries = retData.count;
                    $vm.totalPage = retData.totalPage;

                    console.log($vm.serviceItems)

                    $vm.startPage = retData.startPage;
                    $vm.endPage = retData.endPage;
                    $vm.isSpinnerShow = false;
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })

            await this.getExportData(QUERY_STRING)
        },
        handlePagination(pg) {
            if (pg != null) {
                this.page = pg - 1
                this.getServiceItem()
            }
        },

        async getExportData(strFilter) {
            let $vm = this;
            const url = 'https://menu.tunai.io/business/sections' + strFilter;

            var result = []
            await $vm.$axios({
                method: 'get',
                url: url,
                baseURL: this.$axios.defaults.baseURL,
                headers: { token: $vm.$session.get('token') }
            })
                .then(function (response) {
                    result = response.data.sections
                })
                .catch((err) => {
                    var error = err.response.data.error;
                    if (error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
            this.serviceExportData = result
            this.setExportData(result)
        },
        setExportData(data) {
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_menu_service`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), " "];
            this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV

            for (var i = 0; i < data.length; i++) {
                this.exportData.push({
                    index: i + 1,
                    name: data[i].name,
                })
            }
        },

        showAddService() {
            this.$refs.dataModal.showAddModal()
        },
        showEditService(item) {
            this.$refs.dataModal.isSpinnerShow = true
            this.selectedItem = item
            this.sTitle = item.name
            this.editToggleModal = true;
            this.$refs.dataModal.showEditModal(item, this.category);
        },

        async onServiceChange() {
            await this.getServiceItem("")

            var item = {}
            for (var i = 0; i < this.serviceItems.length; i++) {
                if (this.serviceItems[i].skuID == this.selectedItem.skuID) {
                    item = this.serviceItems[i]
                    break
                }
            }
            this.$refs.dataModal.showEditModal(item, this.category);
        },
        onServiceAddOrEdit() {
            this.getServiceItem()
        },
    },
    async mounted() {
        let $vm = this;
        $vm.getServiceItem();
    }
}
</script>
<style scoped>
.show {
    display: block;
}
</style>
<style>
.nav-link,
.link {
    cursor: pointer;
}

.link>i {
    font-size: large;
}

.modal-body {
    max-height: 65vh;
    overflow-y: auto;
}

.modal-lg {
    max-width: 1000px;
}

.width-12 {
    width: 12%;
}
</style>